import { Image } from '~/components/Image'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import { getImageSrc } from '~/helpers'
import { usePage } from '~/hooks'
import { EmptyContainerPlaceholderProps } from './EmptyContainerPlaceholder.types'

const EmptyContainerPlaceholder = ({
  title,
  description,
  image,
}: EmptyContainerPlaceholderProps) => {
  const page = usePage()
  const isRTM = page.brand === 'rtm'

  return (
    <div className='flex flex-col items-center py-6 md:py-9'>
      {image.src && (
        <Image
          src={getImageSrc(image.src, '200')}
          addSrcSet={false}
          alt={image.altText || ''}
          width={image.width || '200'}
          height={image.height || '200'}
          style={{
            objectFit: 'contain',
            width: 200,
            height: 200,
          }}
        />
      )}
      <div className='max-w-sm text-center mt-6'>
        {title && (
          <Typography
            tag={TypographyTag.p}
            variant={
              isRTM
                ? TypographyVariant.Heading5
                : TypographyVariant.BodyLargeBold
            }
            className='mt-6'>
            {title}
          </Typography>
        )}
        {description && (
          <Typography
            tag={TypographyTag.p}
            variant={
              isRTM
                ? TypographyVariant.BodyRegularExtraLineHeight
                : TypographyVariant.BodyRegular
            }
            className='text-grey-600 mt-2'>
            {description}
          </Typography>
        )}
      </div>
    </div>
  )
}

export default EmptyContainerPlaceholder
